import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";
import { CompanyProfile } from "../types/company";

export const companySlice = createApi({
  reducerPath: "companySlice",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Company"],
  endpoints: (builder) => ({
    getCompanyProfile: builder.query<CompanyProfile, void>({
      query: () => "/company/profile",
      providesTags: ["Company"],
    }),
    updateCompanyProfile: builder.mutation({
      query: (profile) => ({
        url: "/company/profile",
        method: "PUT",
        body: profile,
      }),
      invalidatesTags: ["Company"],
    }),
  }),
});

export const { useGetCompanyProfileQuery, useUpdateCompanyProfileMutation } =
  companySlice;
